import _ from 'lodash';

export var flash = {
  methods: {
    flash(type, message) {            
      this.$buefy.toast.open({
        message: message, 
        type: 'is-' + type, 
      })
    },
    flashSuccess(message, position="is-top", duration=2000) {            
      this.$buefy.toast.open({
        message: message, 
        type: 'is-success', 
        position: position,
        duration: duration,
      })
    },
    flashError(err, position="is-top", duration=2000) { 
      var message = 'Ocorreu um erro!'

      if (err) {
        // Verifica se o erro é uma string
        if (err instanceof String || typeof err === 'string') {
          message = err
        } 
        // Verifica se err.body existe antes de acessar suas propriedades
        else if (err.body && err.body.message) {
          if (err.body.message instanceof String || typeof err.body.message === 'string') {
            message = err.body.message
          } else if (err.body.message instanceof Object) {
            message = Object.values(err.body.message)[0];
          }
        }
        // Fallback para err.message (Error objects)
        else if (err.message) {
          message = err.message
        }
        // Fallback para err.statusText (HTTP responses sem body)
        else if (err.statusText) {
          message = `Erro: ${err.statusText}`;
        }
        // Fallback para erro com status
        else if (err.status) {
          message = `Erro ${err.status}: Ocorreu um erro na requisição.`;
        }
      }

      this.$buefy.toast.open({
        message: message, 
        type: 'is-danger', 
        position: position,
        duration: duration,
      })
    }
  }
};